var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRole = function SvgRole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "M21 9.333c-1.95-.733-4.373-1.167-7-1.167S8.95 8.6 7 9.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "M8.133 9.334 7.28 7.686c-.675-1.308-1.012-1.961-.8-2.54.213-.577.867-.784 2.176-1.198l4.632-1.464c.316-.1.475-.15.637-.15s.32.05.636.15l4.945 1.563c1.179.373 1.768.559 1.993 1.082s-.017 1.147-.5 2.394L20.3 9.334M8.168 9.334v2.013c0 2.092 1.075 4.03 2.832 5.107l.6.368a4.59 4.59 0 0 0 4.802 0l.6-.368c1.758-1.076 2.833-3.015 2.833-5.107V9.334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "m17.499 16.334 1.166 3.5m0 0-1.597 1.395c-1.463 1.277-2.194 1.916-3.07 1.916s-1.606-.639-3.069-1.916l-1.597-1.395m9.333 0 2.024.674c1.164.389 1.746.583 2.263.883.506.293.965.661 1.361 1.091.405.44 1.352 2.019 1.352 3.185M9.332 19.834l1.167-3.5m-1.167 3.5-2.023.674c-1.165.389-1.747.583-2.264.883a5.8 5.8 0 0 0-1.36 1.091c-.406.44-1.353 2.019-1.353 3.185"
  })));
};
export default SvgRole;